import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Button, DatePicker, Form, Input, Modal, message } from "antd";
import TextArea from "antd/es/input/TextArea";
import { useAddReservationMutation } from "../../redux/Service/api";

const AddReservationModal = ({
  open,
  setOpen,
  branchName = "",
  customerId = "",
  tripTypeName = "",
  countryToName = "",
  countryFromName = "",
  tripName = "",
}: any) => {
  const [form] = Form.useForm();
  const [addReservation, { isLoading: isAdding }] = useAddReservationMutation();

  useEffect(() => {
    form.setFieldsValue({
      BranchID: branchName,
      CustomerID: customerId,
      TripTypeID: tripTypeName,
      CountryToID: countryToName,
      CountryFromID: countryFromName,
      TripNo: tripName,
    });
  }, [
    branchName,
    customerId,
    tripTypeName,
    countryToName,
    countryFromName,
    tripName,
  ]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      const requestBody = {
        ReserveDate: values.ReserveDate.format("YYYY-MM-DD"),
        CustomerID: values.CustomerID,
        BranchID: values.BranchID,
        ReserveUserID: 0,
        TripTypeID: values.TripTypeID,
        TripNo: values.TripNo,
        TripDate: values.TripDate.format("YYYY-MM-DD"),
        CountryFromID: values.CountryFromID,
        CountryToID: values.CountryToID,
        PersonsCount: values.PersonsCount || 1,
        Total: "0",
        Payed: "0",
        Notes: values.Notes,
        SitsNumbers: values.SitsNumbers || [],
      };

      const response = await addReservation(requestBody).unwrap();
      message.success("تمت انشاء الحجز بنجاح");
      form.resetFields();
      setOpen(false);
    } catch (error) {
      console.error("Error creating reservation:", error);
      message.error("فشل إنشاء الحجز. حاول مرة أخرى.");
    }
  };

  const handleCancel = () => {
    form.resetFields();
    setOpen(false);
  };

  return (
    <Modal
      title="حجز رحلة"
      open={open}
      onCancel={handleCancel}
      footer={null}
      style={{ top: 20, maxHeight: "90vh", overflow: "auto" }}
    >
      <Form
        form={form}
        name="bookFlight"
        layout="vertical"
        initialValues={{ PersonsCount: 1, Total: 0, Payed: 0 }}
        onFinish={handleOk}
        disabled={isAdding}
      >
        <Form.Item
          label="تاريخ الحجز"
          name="ReserveDate"
          rules={[{ required: true, message: "يرجى اختيار تاريخ الحجز" }]}
        >
          <DatePicker size="large" className="w-full" />
        </Form.Item>
        <Form.Item
          label="الفرع"
          name="BranchID"
          rules={[{ required: true, message: "يرجى اختيار الفرع" }]}
        >
          <Input size="large" disabled />
        </Form.Item>
        <Form.Item
          label="نوع الحجز"
          name="TripTypeID"
          rules={[{ required: true, message: "يرجى اختيار نوع الحجز" }]}
        >
          <Input size="large" disabled />
        </Form.Item>
        <Form.Item
          label="اسم الخدمة"
          name="TripNo"
          rules={[{ required: true, message: "يرجى إدخال رقم الخدمة" }]}
        >
          <Input size="large" disabled />
        </Form.Item>
        <Form.Item
          label="تاريخ الخدمة"
          name="TripDate"
          rules={[{ required: true, message: "يرجى اختيار تاريخ الخدمة" }]}
        >
          <DatePicker size="large" className="w-full" />
        </Form.Item>
        <Form.Item
          label="من"
          name="CountryFromID"
          rules={[{ required: true, message: "يرجى اختيار الدولة" }]}
        >
          <Input size="large" disabled />
        </Form.Item>
        <Form.Item
          label="إلى"
          name="CountryToID"
          rules={[{ required: true, message: "يرجى اختيار الدولة" }]}
        >
          <Input size="large" disabled />
        </Form.Item>
        <Form.Item label="ملاحظات" name="Notes">
          <TextArea size="large" rows={2} />
        </Form.Item>
        <div className="flex justify-end">
          <Button
            onClick={handleCancel}
            size="large"
            style={{ marginRight: 8 }}
          >
            إلغاء
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            size="large"
            loading={isAdding}
          >
            حفظ
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

AddReservationModal.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  branchName: PropTypes.string,
  customerId: PropTypes.string,
  tripTypeName: PropTypes.string,
  countryToName: PropTypes.string,
  countryFromName: PropTypes.string,
  tripName: PropTypes.string,
};

export default AddReservationModal;
